import script from "./DrugDetailDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrugDetailDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DrugDetailDialog.vue?vue&type=style&index=0&id=68f8cb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f8cb9e"]])

export default __exports__